import { createContext, useContext } from "react";

// Lets the console open the sidebar sheet that AppShell owns, without either
// file importing the other.
//
// null means there is no shell: login and the public QR page render the console
// OUTSIDE AppShell, and a hamburger that cannot open anything is worse than no
// hamburger. Consumers must check.
export const ShellContext = createContext(null);
export const useShell = () => useContext(ShellContext);
